module.exports = __webpack_public_path__ + "ba08e00f2d4fd6b060d7a413b5c86ce2.woff";